import {Injectable} from "@angular/core";
import {BekreftelseDialogKomponent, DialogParametre} from "../delt/komponenter/dialog/bekreftelse-dialog/bekreftelse-dialog";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {firstValueFrom, Observable} from "rxjs";
import {DialogParametre as SlettMedÅrsakDialogParametre, SlettMedÅrsakDialogKomponent, SlettMedÅrsakDialogRespons} from "web-ng2/delt/komponenter/dialog/slett-med-årsak-dialog/slett-med-årsak-dialog";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";

/** Tjeneste for å vises bekreftelsesdialog  */
@Injectable({providedIn: 'root'})
export class Bekreftelsesdialog {

    constructor(private dialog: MatDialog) {
    }

    visInfo(konfigurasjon: DialogParametre): BekreftelsesdialogResultat {
        return new BekreftelsesdialogResultat(BekreftelseDialogKomponent.visInfo(this.dialog, konfigurasjon));
    }

    visAdvarsel(konfigurasjon: DialogParametre): BekreftelsesdialogResultat {
        return new BekreftelsesdialogResultat(BekreftelseDialogKomponent.visAdvarsel(this.dialog, konfigurasjon));
    }

    visFare(konfigurasjon: DialogParametre): BekreftelsesdialogResultat {
        return new BekreftelsesdialogResultat(BekreftelseDialogKomponent.visFare(this.dialog, konfigurasjon));
    }

    visSlettMedÅrsak(konfigurasjon: SlettMedÅrsakDialogParametre): SlettMedÅrsakBekreftelsesdialogResultat {
        return new SlettMedÅrsakBekreftelsesdialogResultat(SlettMedÅrsakDialogKomponent.vis(this.dialog, konfigurasjon));
    }
}

export class BekreftelsesdialogResultat {

    constructor(private matDialogRef: MatDialogRef<BekreftelseDialogKomponent, boolean>) {
    }

    somPromiseVedOk(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.somPromise().then(respons => {
                if (respons === true) resolve();
            })
        });
    }

    somPromise(): Promise<boolean | undefined> {
        return firstValueFrom(this.matDialogRef.afterClosed(), {defaultValue: false});
    }

    somObservable(): Observable<boolean | undefined> {
        return this.matDialogRef.afterClosed();
    }
}

export class SlettMedÅrsakBekreftelsesdialogResultat {

    constructor(private matDialogRef: MatDialogRef<SlettMedÅrsakDialogKomponent, SlettMedÅrsakDialogRespons>) {
    }

    somPromiseVedOk(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.somPromise().then(respons => {
                if (erIkkeTomStreng(respons)) resolve(respons);
            })
        });
    }

    somPromise(): Promise<string | null> {
        // @ts-ignore
        return firstValueFrom(this.matDialogRef.afterClosed(), {defaultValue: null});
    }

    somObservable(): Observable<string | null> {
        // @ts-ignore
        return this.matDialogRef.afterClosed();
    }
}
